"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selection = void 0;
var utilities_1 = require("@fluentui/utilities");
Object.defineProperty(exports, "Selection", { enumerable: true, get: function () { return utilities_1.Selection; } });
//# sourceMappingURL=Selection.js.map